
import { Component, Vue } from 'vue-property-decorator'
import BgComp from '../components/bgComp.vue'
import { Getter } from 'vuex-class'
import { brushFaceByIDCard } from '@/api/approve'
@Component({
  name: 'FaceConfirm',
  components: {
    BgComp
  }
})
export default class FaceConfirm extends Vue {
  @Getter companyId: string // 公司编号
  currentRate = 0
  isApproveShow = false
  orderNo = ''

  created() {
    console.log('route', this.$route.query)
    this.changeNativeAreaColor(true)
  }
  handleBack() {
    this.$router.back()
    // if(this.$route.query.flag) {
    //   this.$router.push({
    //     name:'UserInfoForm'
    //   })
    // }else {
    //   this.$router.push({
    //     name:'CompanyInfoForm'
    //   })
    // }
  }
  // 判断是否是公司
  isCompany() {
    return this.$route.query.flag ? 2 : 3
  }
  handleBtn() {
    // let { title } = this.$route.query
    // this.$router.push({
    //   name:'FaceResult'
    // })
    let data = {
      companyId: this.companyId,
      // 业务类型 2、身份认证 3、企业认证
      businessType: this.isCompany()
    }
    brushFaceByIDCard(data)
      .then((res) => {
        console.log('res12', res)

        if (res.code === '000000') {
          let orderNo = res.data.orderNo
          let obj = {
            orderNo,
            companyId: this.companyId,
            flag: this.$route.query.flag,
            unifiedSocialCreditCode: this.$route.query.unifiedSocialCreditCode
          }
          window.localStorage.setItem('approve', JSON.stringify(obj))
          window.localStorage.setItem('faceHistoryNum', `${window.history.length}`)
          window.location.href = res.data.url
        } else if (res.code === '000002') {
          this.$dialog
            .alert({
              message: res.msg
            })
            .then(() => {
              // on confirm
              // if (this.$route.query.flag) {
              //   this.$router.push({
              //     name: 'UserInfoForm'
              //   })
              // } else {
              //   this.$router.push({
              //     name: 'CompanyInfoForm'
              //   })
              // }
              this.$router.back()
            })
        } else {
          this.$toast(res.msg)
        }
      })
      .catch((res) => {
        console.log('res catch', res)
        console.log('11111')
      })
      .finally(() => {
        console.log('111')
      })
  }

  destroyed() {
    this.changeNativeAreaColor(false)
  }

  changeNativeAreaColor (isCreated: boolean) {
    const params = {
      statusBarColor: 'FFFFFF',  // 状态栏颜色
      bottomColor: isCreated ? 'F3F3F3' : 'FFFFFF', // 底部安全区颜色
      alpha: 1
    }
    this.$bridge.callHandler('changeNativeAreaColor', params, (res) => {
    })
  }
}
